/*
 * @Author: zhouxingtong
 * @Email: 495144492@qq.com
 * @Date: 2024-06-04 17:48:23
 * @LastEditors: zhouxingtong
 * @LastEditTime: 2024-12-12 13:49:02
 * @Description:
 */
import { watch, ref } from 'vue'
import { isString } from '@/utils/is'
import { useAppStoreWithOut } from '@/store/modules/app'
import { useI18n } from '@/hooks/web/useI18n'

export const useTitle = (newTitle?: string) => {
  const { t } = useI18n()
  const appStore = useAppStoreWithOut()

  const title = ref(
    newTitle ? `${appStore.getTitle} - ${t(newTitle as string)}` : appStore.getTitle
  )

  watch(
    title,
    (n, o) => {
      if (isString(n) && n !== o && document) {
        document.title = import.meta.env.VITE_APP_TITLE
      }
    },
    { immediate: true }
  )

  return title
}
